'use client'

import * as React from 'react'
import { SliderProps } from './types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import ChevronLeftIcon from '../../icons/ChevronLeftIcon'
import ChevronRightIcon from '../../icons/ChevronRightIcon'
import useSwiperRef from '../../hooks/useSwiperRef'

const SwiperComponent = ({ slides }: SliderProps) => {
    const [nextEl, nextElRef] = useSwiperRef<HTMLDivElement>()
    const [prevEl, prevElRef] = useSwiperRef<HTMLDivElement>()
    return (
        <div className="select-none lg:hidden">
            <Swiper
                className="relative flex h-[342px] items-center [&>.swiper-button-disabled]:pointer-events-none [&>.swiper-button-disabled]:bg-gray-300"
                navigation={{
                    nextEl: nextEl,
                    prevEl: prevEl,
                }}
                modules={[Navigation]}
                loop={false}
                slidesPerView={1}
            >
                {slides?.map((slide, index) => (
                    <SwiperSlide
                        className={'flex h-auto w-full [&>img]:w-full [&>img]:object-cover '}
                        key={`swiper_${index}`}
                    >
                        {slide}
                    </SwiperSlide>
                ))}
                <div
                    className="absolute left-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black hover:cursor-pointer"
                    ref={prevElRef}
                >
                    <ChevronLeftIcon />
                </div>
                <div
                    className="absolute right-2 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-black hover:cursor-pointer"
                    ref={nextElRef}
                >
                    <ChevronRightIcon />
                </div>
            </Swiper>
        </div>
    )
}

export default SwiperComponent
